export function combineTreatmentFacility(formData) {
  const parsedFormData = JSON.parse(formData);
  const transformedValue = parsedFormData;
  if (parsedFormData?.treatments?.length) {
    transformedValue.treatments = parsedFormData.treatments.map(center => {
      // Support both new facilityInfo wrapper and 2022 fields for backward compatibility with in-progress forms created before the wrapper was added
      const name =
        center.facilityInfo?.vaMedicalCenterName ?? center.vaMedicalCenterName;
      const city = center.facilityInfo?.city ?? center.city;
      const state = center.facilityInfo?.state ?? center.state;

      return {
        ...center,
        facility: `${name} - ${city}, ${state}`,
        treatmentDates: {
          start: center.startDate,
          end: center.endDate,
        },
      };
    });
  }
  return JSON.stringify(transformedValue);
}
